import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import RenderTextFieldReduxEmail from '../Complements/RenderTextFieldReduxEmail';
import { Field, reduxForm } from 'redux-form';
import Grid from '@material-ui/core/Grid';
import { Button } from '@material-ui/core';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import renderDecimalTextField from '../Complements/renderDecimalTextFiel';
import { withStyles } from '@material-ui/styles';

const useStyles = theme => ({
    buttonStandard: {
        fontSize: '1rem',
        color: '#ffffff',
        borderRadius: '4px',
        '&.Mui-disabled': {
            backgroundColor: "#a7a8a8",
        },
        '&:hover': {
            backgroundColor: "#706D85",
        },
        backgroundColor: "#2E2757",
        //fontFamily: 'MyriadPro-Bold',
    },
})



const validate = values => {
    const error = {}
    const pattern = new RegExp('^[A-Za-z0-9 ]+$', 'i');
    //const patternAmount = new RegExp('^[0-9]+([.][0-9]{2})?$')

    if (!values.amount) {
        error.amount = "El monto es un campo obligatorio"
    }
    if (parseFloat(values.amount) <= 0) {
        error.amount = "El monto debe ser mayor a 0"
    }
    if (!values.concept) {
        error.concept = "La descripción es un campo obligatorio"
    }
    if (!pattern.test(values.concept)) {
        error.concept = "El concepto solo permite letras y espacios"
    }
    if (/^[0-9]+([.][0-9]{0,2})?$/.test(values.amount) === false) {
        error.amount = "El monto solo debe tener 2 decimales. Ejemplo: 3.22"
    }
    if (values.concept) {
        if (values.concept.toString().length > 60) {
            error.concept = "El concepto solo permite hasta 60 caracteres."
        }
    }
    return error
}

class TransferForm extends Component {


    render() {
        const { handleSubmit, valid, submitting, cancelButton, email } = this.props;

        return (
            <React.Fragment>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12}>
                            <Field
                                withFocus
                                autoFocus={true}
                                name="email"
                                id="email"
                                required
                                defaultValue={email}
                                component={RenderTextFieldReduxEmail}
                                label="Correo Electrónico"
                                fullWidth
                                // textTransform={'lowercase'}
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Field
                                withFocus
                                name="amount"
                                id="amount"
                                simbol='$'
                                component={renderDecimalTextField}
                                label="Monto"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Field
                                withFocus
                                name="concept"
                                id="concept"
                                required
                                multiline
                                rows="4"
                                upperCase={true}
                                component={RenderTextFieldRedux}
                                label="Concepto"
                                autoComplete="off"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <Button variant="contained" type="submit"
                                disabled={!valid || submitting}
                                color = "primary"
                                fullWidth
                            >
                                Continuar
                            </Button>
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <Button variant="outlined"
                                color='primary'
                                onClick={cancelButton}
                                fullWidth
                            >
                                Cancelar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </React.Fragment>
        )
    }
}

const TransferReduxForm = reduxForm(
    {
        form: 'TransferForm',
        validate
    }
)(TransferForm)

export default setPropsAsInitial(withStyles(useStyles)(TransferReduxForm))
